function removeLastSlash(str = '') {
  if (str === '/') return str;
  return str.replace(/\/$/, '');
}

// NN api url
if (!process.env.NX_PUBLIC_API_URL) {
  throw new Error('API URL is not specified');
}
export const ApiUrl = process.env.NX_PUBLIC_API_URL;
// api version
export const ApiAppVersion = process.env.NX_PUBLIC_API_VERSION || '3.0.0';
// base path to assets on S3
export const AssetsBaseUrl = removeLastSlash(process.env.NX_PUBLIC_ASSETS_URL);
// base url to locales bucket on S3
export const LocalesBaseUrl = removeLastSlash(process.env.NX_PUBLIC_LOCALES_URL);
// allowed backUrl whitelist
export const BackUrlWhitelist = process.env.NX_PUBLIC_URL_WHITELIST ?? '';
// url to onboarding app
export const OnboardingAppPath = removeLastSlash(process.env.NX_PUBLIC_SSO_ONBOARDING_URL);
// url to assessment part of the onboarding app
export const OnboardingAppAssessmentPath =
  OnboardingAppPath === '/' ? '/assessment' : `${OnboardingAppPath}/assessment`;
// url to training app
export const TrainingAppPath = removeLastSlash(process.env.NX_PUBLIC_SSO_TRAINING_URL);
// url to subscribe app
export const SubscribeAppPath = removeLastSlash(process.env.NX_PUBLIC_SSO_SUBSCRIBE_URL);
// url to the blog
export const BlogPath = removeLastSlash(process.env.NX_PUBLIC_BLOG_URL);
// onboarding url whitelist
export const OnboardingUrlWhitelist = process.env.NX_PUBLIC_ONBOARDING_URL_WHITELIST ?? '';

export const IsDebug = !!process.env.NX_PUBLIC_DEBUG;
// passkey feature toggle
export const PasskeyOn = (process.env.NX_PUBLIC_SSO_PASSKEY ?? 'off') === 'on';
// base path
export const BasePath = process.env.NX_PUBLIC_BASE_PATH || process.env.NX_PUBLIC_URL || '/';
// Password complexity
export const EnforcePasswordComplexity = (process.env.NX_PUBLIC_ENFORCE_PASSWORD_COMPLEXITY || 'yes') === 'yes';

const BUILD_ID_FALLBACK = 'local-build';
export const BuildID = process.env.NX_PUBLIC_BUILD_ID || BUILD_ID_FALLBACK;

// Firebase config object
let FirebaseConfigBase;
if (process.env.NODE_ENV === 'test') {
  FirebaseConfigBase = {
    apiKey: 'mock-api-key',
    authDomain: 'mock-auth-domain',
    databaseURL: 'mock-database-url',
    projectId: 'mock-project-id',
    storageBucket: 'mock-storage-bucket',
    messagingSenderId: 'mock-messaging-sender-id',
    appId: 'mock-app-id',
    measurementId: 'mock-measurement-id',
  };
} else {
  FirebaseConfigBase = {
    apiKey: process.env.NX_PUBLIC_FIREBASE_API_KEY ?? '',
    authDomain: process.env.NX_PUBLIC_FIREBASE_DOMAIN,
    databaseURL: process.env.NX_PUBLIC_FIREBASE_URL,
    projectId: process.env.NX_PUBLIC_FIREBASE_PROJECT_ID ?? '',
    storageBucket: process.env.NX_PUBLIC_FIREBASE_BUCKET,
    messagingSenderId: process.env.NX_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: process.env.NX_PUBLIC_FIREBASE_APP_ID ?? '',
    measurementId: process.env.NX_PUBLIC_FIREBASE_MEASUREMENT_ID ?? '',
  };
}
export const FirebaseConfig = FirebaseConfigBase;
